import { Button, Col, DatePicker, message, Modal, Row } from "antd";
import moment from "moment/moment";
import { FC, useState } from "react";
import Icon from "../../../assets/icons/icon";
import PopoverList from "../../../components/popups/popoverList";
import LeasingStore from "../../../contexts/leasingStore";
import _t from "../../../lang/translate";
import { generatePaymentAdviceFirstTimePreview, sendPaymentAdviceFirstTimeEmail } from "../../../services/leasingService";
import { isAxiosError } from "../../../utilities/typeGuard";


const LeasingGeneratePaymentAdviceFirstTimeDocument: FC = () => {
  const { leasingCase } = LeasingStore.useContainer();
  const [loading, setLoading] = useState<boolean>(false);

  const [paymentDate, setPaymentDate] = useState<string | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const closeModal = () => setShowModal(false)

  const disabled = !leasingCase.flags.validationStarted;

  const handlePreview = async () => {
    try {
      setLoading(true);
      const { data } = await generatePaymentAdviceFirstTimePreview(leasingCase.id, paymentDate);
      if (data.url) {
        window.open(data.url, '_blank');
      }
    } catch (error) {
      const errorMessage = isAxiosError(error)
        ? error.response?.data?.message
        : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async () => {
    try {
      setLoading(true);
      await sendPaymentAdviceFirstTimeEmail(leasingCase.id, paymentDate);
      closeModal();
      message.success(_t("sent"));
    } catch (error) {
      const errorMessage = isAxiosError(error)
        ? error.response?.data?.message
        : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PopoverList list={[
        !leasingCase.flags.validationStarted ? "Påbegynd validering først" : null,
      ].filter(Boolean) as string[]}>
        <Button loading={loading} disabled={disabled} onClick={() => setShowModal(true)} icon={<Icon name="paper-plane-outline" />}>
          {_t("send", "downpaymentAdvice")}
        </Button>
      </PopoverList>

      <Modal
        confirmLoading={loading}
        width={800}
        visible={showModal}
        onCancel={closeModal}
        title={_t("paymentAdviceDocumentFirstTime")}
        okText={_t("send", 'paymentAdviceDocumentFirstTime')}
        onOk={handleSend}
      >
        <Row>
          <Col span={24}>
            <DatePicker
              allowClear={true}
              value={paymentDate ? moment(paymentDate) : null}
              onChange={(date, dateString) => setPaymentDate(dateString)}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24} className="text-right pt-1">
            <Button type="link" size="small" onClick={handlePreview}>
              {_t('preview')}
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default LeasingGeneratePaymentAdviceFirstTimeDocument;
